<script>
export let currentRoute;


import CodeSeeNew from 'components/views/auth/elements/code/SeeNew.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Loading from 'components/elements/Loading.svelte';
import Error from 'components/elements/Error.svelte';


import SvelteSeo from 'svelte-seo';


const api_url = app_.env.API_URL;

let token = currentRoute.namedParams.token; 


let msg_show = false;
let msg_type;
let msg_text;



let promise = verifyToken();

async function verifyToken() {

	let form_data = new FormData();

	form_data.append('token', token);

	const url = `${api_url}auth/coach/code/set-new`;

	const resp = await fetch(url, {
		method: 'POST',
		body: form_data,
	});

	const result = await resp.json();

	if (!resp.ok) {
		msg_show = true;
		msg_type = 'error';
		msg_text = response.detail;
		throw new Error('Error!');
	}
	
	return result;

}


</script>



<style>

#code-see-new-card {

}

</style>


<SvelteSeo
	title='Your New Code | AHG Coaches Portal'
	description='Your New Code!'
/>


{#await promise}

<Loading />

{:then msg}

<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Your new code: <span style="text-decoration: underline;">{msg.new_code}</span>
			</p>

		</div>

	</div>

</section>


<section class="section">
	
	<div class="container">

		<div class="columns is-centered">

			<div class="column is-5-desktop is-8-tablet is-12-mobile">

				<MsgCard bind:msg_show={msg_show} bind:msg_type={msg_type} bind:msg_text={msg_text} />

				<CodeSeeNew bind:msg_show={msg_show} bind:msg_type={msg_type} bind:msg_text={msg_text} code={msg.new_code} />

			</div>

		</div>

	</div>

</section>

{:catch error}

<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-5-desktop is-8-tablet is-12-mobile">

				<MsgCard msg_show={true} msg_type={'error'} msg_text={'This token is either expired or invalid!'} />

			</div>

		</div>

	</div>

</section>

{/await}





